export enum VerticalTabsTitle  {
  Library = "LIBRARY",
  Versions = "COMPAREVERSIONS",
  Metrics = "METRICS",
  Report = "REPORT",
  References = "REFERENCES",
}
